import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '@/views/AboutView.vue'
import TechnoView from '@/views/TechnoView.vue'
import IndustryView from '../views/IndustryView.vue'
import ProductView from '@/views/ProductView.vue'
import PublicView from '@/views/PublicView.vue'
import ContactView from '@/views/ContactView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/technology',
    name: 'technology',
    component: TechnoView
  },
  {
    path: '/industry',
    name: 'industry',
    component: IndustryView
  },
  {
    path: '/product',
    name: 'product',
    component: ProductView
  },
  {
    path: '/publication',
    name: 'publication',
    component: PublicView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
